import * as React from "react";
import { forwardRef } from "react";
const SvgResumeTimer = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 2.19403C2 1.81032 2.41435 1.56961 2.74767 1.75968L12.9297 7.56566C13.2662 7.7575 13.2662 8.24252 12.9297 8.43436L2.74767 14.2403C2.41435 14.4304 2 14.1897 2 13.806V2.19403Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgResumeTimer);
export default ForwardRef;
